import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';
import {getCreditPoints } from './apiService';

// Define the context type
interface CreditPointsContextType {
    creditPoints: any;
    setCreditPoints: (points: number) => void;
    fetchCreditPoints: (userId: any) => Promise<void>;
}

// Create a context with undefined as the initial value
const CreditPointsContext = createContext<CreditPointsContextType | undefined>(undefined);

interface CreditPointsProviderProps {
    children: ReactNode;
}

export const CreditPointsProvider: React.FC<CreditPointsProviderProps> = ({ children }) => {
    const [creditPoints, setCreditPoints] = useState<number>(0);


    const fetchCreditPoints = useCallback(async (userId: any) => {
        if (!userId) return;

        try {
            const response = await getCreditPoints(userId);
            if ((response && response.status === 200) || response?.status === "success") {
                const balance = response.data?.data?.balance || 0;
                localStorage.setItem("creditPoints", balance.toString());
                setCreditPoints(balance);
            }
        } catch (err) {
            console.error("Failed to fetch credit points:", err);
        }
    }, []);

    return (
        <CreditPointsContext.Provider value={{ creditPoints, setCreditPoints, fetchCreditPoints }}>
            {children}
        </CreditPointsContext.Provider>
    );
};

export const useCreditPoints = () => {
    const context = useContext(CreditPointsContext);
    if (context === undefined) {
        throw new Error('useCreditPoints must be used within a CreditPointsProvider');
    }
    return context;
};
